// Cores do projeto PasiAI
export const COLORS = {
  // Cor primária do projeto
  PRIMARY: '#008B95',
  
  // Variações da cor primária
  PRIMARY_LIGHT: '#2dd4bf',
  PRIMARY_DARK: '#0f766e',
  
  // Cores de suporte
  SUCCESS: '#10b981',
  WARNING: '#f59e0b',
  ERROR: '#ef4444',
  INFO: '#3b82f6',
  
  // Cores neutras
  WHITE: '#ffffff',
  BLACK: '#000000',
  GRAY_50: '#f9fafb',
  GRAY_100: '#f3f4f6',
  GRAY_200: '#e5e7eb',
  GRAY_300: '#d1d5db',
  GRAY_400: '#9ca3af',
  GRAY_500: '#6b7280',
  GRAY_600: '#4b5563',
  GRAY_700: '#374151',
  GRAY_800: '#1f2937',
  GRAY_900: '#111827',
} as const

// Classes do Tailwind para as cores
export const TAILWIND_COLORS = {
  PRIMARY: 'bg-primary-500 text-white',
  PRIMARY_HOVER: 'hover:bg-primary-600',
  PRIMARY_BORDER: 'border-primary-500',
  PRIMARY_TEXT: 'text-primary-500',
  
  // Variações
  PRIMARY_LIGHT: 'bg-primary-400',
  PRIMARY_DARK: 'bg-primary-700',
  
  // Estados
  SUCCESS: 'bg-green-500 text-white',
  WARNING: 'bg-yellow-500 text-white',
  ERROR: 'bg-red-500 text-white',
  INFO: 'bg-blue-500 text-white',
} as const

// Exporta a cor primária como constante principal
export const BRAND_COLOR = COLORS.PRIMARY
